import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';

interface SubmitScoutIssueParams {
  session_id: string;
  description: string;
  url: string;
}

export const scoutFeedbackApi = createApi({
  reducerPath: 'scoutFeedback',
  baseQuery: baseQueryWithTokenHandling,
  endpoints: (builder) => ({
    submitScoutIssue: builder.mutation<void, SubmitScoutIssueParams>({
      query: (data) => ({
        url: `/v1/ai/report-issue/`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useSubmitScoutIssueMutation } = scoutFeedbackApi;
